/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.tiposmovimientos': 'Tipos Movimientos',
  'tiposMovimientos.agregarTiposMovimientos': 'Crear Tipos Movimientos',
  'tiposMovimientos.modificarTiposMovimientos': 'Editar Tipos Movimientos',
  'tiposMovimientos.tipoMovimientoId': 'Tipo Movimiento Id',
  'tiposMovimientos.empresaId': 'Empresa Id',
  'tiposMovimientos.tipoMovimientoDescripcion': 'Descripción',
  'tiposMovimientos.VerTiposMovimientos': 'Ver Tipos Movimientos',
};
